// extracted by mini-css-extract-plugin
export default {"ApplicationsPage__Wrapper":"ApplicationsPage_ApplicationsPage__Wrapper__wyTEw","ApplicationsPage__Preloader":"ApplicationsPage_ApplicationsPage__Preloader__-pCRi"};